import { DiaryEventGroup } from "../models/diary-event-group"
import { DiaryEvent } from "../models/diary-event"

export class DiaryEventKeySet {

  private eventDateKeys = new Set<string>();

  constructor(diaryEventGroups: DiaryEventGroup[]) {
    this.storeEventDateKeys(diaryEventGroups);
  }

  /**
   * Returns true if the month has any events 
   * @param standardMonthNumber Standard JS zero based month number (0-11)
   */
  hasEventsInMonth(standardMonthNumber: number): boolean {
    const values = Array.from(this.eventDateKeys.values()); // todo: optimisation, maybe store "month" and "year" codes in their own sets, reduce iteration
    for (let item of values) {
      if (item.includes(`:${standardMonthNumber}:`)) {
        return true;
      }      
    }
    return false;    
  }

  /**
   * Returns true if the year has any events 
   * @param yearNumber four digit year
   */
  hasEventsInYear(yearNumber: number): boolean {
    const values = Array.from(this.eventDateKeys.values()); // todo: optimisation, maybe store "month" and "year" codes in their own sets, reduce iteration
    for (let item of values) {
      if (item.endsWith(`:${yearNumber}`)) {
        return true;
      }
    }
    return false;
  }


  /**
   * Returns true if the date has events
   * @param primeNgDate Date as passed from PrimeNg calendar (has .day, .month, .year properties)
   */
  hasPrimeNgDate(primeNgDate: any): boolean {
    const key = this.primeNgDateToKey(primeNgDate);
    return this.eventDateKeys.has(key);
  }

  private dateToKey(date: Date): string {
    const day: string = date.getDate().toString();
    const month: string = date.getMonth().toString();
    const year: string = (date.getFullYear()).toString();
    const key: string = (`${day}:${month}:${year}`);
    return key;
  }

  private primeNgDateToKey(primeNgDate: any): string {
    const key: string = (`${primeNgDate.day}:${primeNgDate.month}:${primeNgDate.year}`);
    return key;
  }

  private storeEventDateKeys(diaryEventGroups: DiaryEventGroup[]): void {

    this.eventDateKeys.clear();
    if (!Array.isArray(diaryEventGroups)) {
      return;
    }

    // get distinct set of event date keys for faster lookup
    diaryEventGroups
      .reduce((arr, elem) => [...arr, ...elem.DiaryEvents], [])
      .map((diaryEvent) => {
        this.eventDateKeys.add(this.dateToKey(diaryEvent.DiaryDate));
      });

  }


}
